import React from 'react';
import { FooterContainer } from '../../Shared/Styled';

export const LoginFooter = () => (
  <FooterContainer>
    <a target='_new' href='https://www.bentley.com/'>
      © {new Date().getFullYear()} Bentley Systems, Incorporated{' '}
    </a>
    <a target='_new' href='https://www.bentley.com/en/privacy-policy'>
      Privacy
    </a>
    <a
      target='_new'
      href='https://www.bentley.com/en/terms-of-use-and-select-online-agreement'
    >
      Terms of Use
    </a>
    <a target='_new' href='https://www.bentley.com/en/about-us/contact-us'>
      Contact Us
    </a>
  </FooterContainer>
);
